/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

export default
class VertexDataDescriptor {

    public semantic: string;
    public nofElements: number;
    public nofComponents: number;
    public sizeofType: number;
    public type: string;
    public offset: number;
    public data: Float32Array|Uint32Array;

    constructor(aSemantic: string, aNofComponents: number, aNofElements: number, aType: string, aSizeofType: number, aByteOffset: number, aData: Float32Array|Uint32Array) {

        this.semantic = aSemantic; // string
        this.nofElements = aNofElements; // number
        this.nofComponents = aNofComponents;/// number
        this.sizeofType = aSizeofType; // number
        this.type = aType; // string
        this.offset = aByteOffset; // number
        this.data = aData; // typed array buffer
    }
}
